module.exports = __webpack_public_path__ + "img/index4.262f845f.png";